import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        let token = sessionStorage.getItem("token")
        if(token != null && token != undefined){
            setUser(token)
        }
    },[])

    async function Login(empresa,usuario,senha) {

        // Empresa: "tox",
        // Usuario: "sysman",
        // Senha: "Sucesso"

        fetch('https://gipapi.azurewebsites.net/Security/Authentication', {
        //fetch('https://localhost:44303/Security/Authentication', { 
            method: "PUT",
            headers: {'Content-type': 'application/json; charset=UTF-8',},
            body: JSON.stringify({
                Empresa: empresa,
                Usuario: usuario,
                Senha: senha
            })
        })
        .then(response => response.json())
        .then(json => {
            if(json.MensagemErro != undefined){
                alert(json.MensagemErro)
            }
            if(json.access_token != null && json.access_token != undefined){
                setUser(json.access_token)
                sessionStorage.setItem("token", json.access_token);
            }
        })
        .catch((err) => {
            console.log(err.message);
        });
    }

    return (
        <AuthContext.Provider value={{ signed: user != null ? true : false, user: user, Login }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;